import { render, staticRenderFns } from "./discountZone.vue?vue&type=template&id=802bf118&scoped=true&"
import script from "./discountZone.vue?vue&type=script&lang=js&"
export * from "./discountZone.vue?vue&type=script&lang=js&"
import style0 from "./discountZone.vue?vue&type=style&index=0&id=802bf118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802bf118",
  null
  
)

export default component.exports